import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

export default function NoAddWorKOrderRightActions({
	exportMenu,
	switchDisplayMode,
	isDisplayModeActive,
	currentUser,
}) {
	const exportButton = (
		<Button size="large" icon={<DownloadOutlined />} className="inline-block-visible-md">
			<span className="inline-block-visible-xxl">Export</span>
		</Button>
	);
	return exportMenu ? exportMenu(exportButton) : exportButton;
}
